import { Component, inject, Input, OnInit }     from '@angular/core';
import { MatToolbar }                           from '@angular/material/toolbar';
import { MatIcon }                              from '@angular/material/icon';
import { MatButton }                            from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { RouterLink }                           from '@angular/router';

import { BankCustomizationData, SessionService } from '../../../api/session/session.service';
import { ComponentType }                         from '../components.utils';
import { InternalRoutes }                        from '../../data/internal-routes';
import { BankCustomizationUtils }                from '../../utils/bank-customization.utils';
import { LogoComponent }                         from '../logo/logo.component';
import { BankLogoComponent }                     from '../../../components/bank-logo/bank-logo.component';

@Component({
  selector: 'pin-new-header',
  templateUrl: './new-header.component.html',
  imports: [MatToolbar, LogoComponent, BankLogoComponent, MatIcon, MatButton, MatMenuTrigger, MatMenu, MatMenuItem, RouterLink]
})
export class NewHeaderComponent implements OnInit {
  @Input()
  customClass: string;
  @Input()
  type: string;
  logoType: string;
  displaySessionDetails: boolean;
  bankName: string;
  displayName: string;
  agentsFeatureEnabled = false;
  ssoUser = false;
  internalRoutes = InternalRoutes;
  hasCustomerLevelAccess = false;
  bankCustomizationData: BankCustomizationData;
  private sessionService = inject(SessionService);
  private headerConfig = {
    public: {
      logoType: ComponentType.PUBLIC,
      displaySessionDetails: false
    },
    new_public: {
      logoType: ComponentType.NEW_PUBLIC,
      displaySessionDetails: false
    },
    registration: {
      logoType: ComponentType.REGISTRATION,
      displaySessionDetails: false
    },
    authenticated: {
      logoType: ComponentType.AUTHENTICATED,
      displaySessionDetails: true
    }
  };

  ngOnInit(): void {
    this.logoType = this.headerConfig[this.type].logoType;
    this.displaySessionDetails = this.headerConfig[this.type].displaySessionDetails;

    if (this.displaySessionDetails) {
      this.getSession();
    }
  }

  getSession(): void {
    const sessionObserveFunction = data => {
      this.bankName = data.bankName;
      this.displayName = `${data.firstName} ${data.lastName}`;
      this.agentsFeatureEnabled = data.agentsFeatureEnabled;
      this.ssoUser = data.sso;
      this.hasCustomerLevelAccess = data.hasCustomerLevelAccess;
      this.bankCustomizationData = data.bankCustomizationData;

      if (data.bankCustomizationData && data.bankCustomizationData.colorCode) {
        BankCustomizationUtils.changeBankCustomizationColor(data.bankCustomizationData.colorCode);
      } else {
        BankCustomizationUtils.resetBankCustomizationColor();
      }
    };

    this.sessionService.registerSessionObserver({next: sessionObserveFunction});
    this.sessionService.loadSession();
  }
}
